module.exports = __webpack_public_path__ + "static/media/COS_OMRON.00d198c4.png";